export default __webpack_public_path__ + "static/media/message-icon.9c439234.svg";